import FAQComponent from "pages/LandingPages/Faq";

export default function FaqPage() {
  return <FAQComponent />;
}
